import { DateTime, MinuteNumbers, WeekdayNumbers, Duration, DurationObjectUnits } from "luxon";
import { DateHelper } from "./DateHelper";
import { appContext } from "../AppContext";

declare module 'luxon/src/datetime'
{
    export interface DateTime
    {
        isNull(): boolean;
        date(): DateTime;
        toLocaleDateString(): string;
        toLocaleTimeString(): string;
        toLocaleDateTimeString(): string;
        toUrl(): string;
        toUrlDate(): string;
        toUrlTime(): string;
    }
}

declare module 'luxon/src/duration'
{
    export interface Duration
    {
        durationToString(): string
    }
}

DateTime.prototype.isNull = function (): boolean
{
    return (!this.isValid && this.invalidReason == "null");
}

DateTime.prototype.date = function (): DateTime
{
    return this.startOf("day");
}

DateTime.prototype.toLocaleDateString = function (): string
{
    return this.toLocaleString(DateTime.DATE_SHORT, { locale: appContext().language.current });
}

DateTime.prototype.toLocaleTimeString = function (): string
{
    return this.toLocaleString(DateTime.TIME_SIMPLE, { locale: appContext().language.current });
}

DateTime.prototype.toLocaleDateTimeString = function (): string
{
    return this.toLocaleString(DateTime.DATETIME_SHORT, { locale: appContext().language.current });
}

DateTime.prototype.toUrl = function (): string
{
    return (this.isValid ? this.toFormat('yyyy-MM-dd_HH-mm-ss') : '');
}

DateTime.prototype.toUrlDate = function (): string
{
    return (this.isValid ? this.toFormat('yyyy-MM-dd') : '');
}

DateTime.prototype.toUrlTime = function (): string
{
    return (this.isValid ? this.toFormat('HH-mm-ss') : '');
}

Duration.prototype.durationToString = function (): string
{
    const hourDiff = this.hours;
    const minuteDiff = this.minutes !== undefined && this.minutes % 60
    return `${hourDiff} hr ${minuteDiff === 0 ? "" : minuteDiff} ${minuteDiff === 0 ? "" : "min"}`
}
